/**
 * Creates a pagination element.
 *
 * options:
 *              maxnumberOfResultPagesShown: if appliable, number of pages selectable
 *
 *              nextCallback/previous: when appliable function called whenever the user clicks
 *                                     'next/previous' button ('next' button is also called for loadMore mode)
 *
 *              loadPageCallback: function called whenever a user want to load a specific page (it has an argument with the page number)
 *
 */

(function() {
    'use strict';
    Odigeo.UIElements.enhancePagination = function($selector, options) {
        if ($selector.attr('data-skip-enhance') === 'true') {
            return $selector;
        }
        $selector.attr({'data-skip-enhance': true});

        // Init vars
        var _options = {
            maxnumberOfResultPagesShown: 5,
            nextCallback: null,
            previousCallback: null,
            loadPageCallback: null,
            loadTrackingCallback: null,
            allowPrismaResponsiveSpaceHorizontal: true,
        };
        var paginationType = $selector.attr('data-pagination-type');
        var $nextButton = $selector.find('.next_button');
        var $previousButton = $selector.find('.previous_button');
        var $pageTemplateButton = $selector.find('.page_template_button').addClass('page_button');
        var $paginationFirstSeparator = $selector.find('.pages_separator');
        var $paginationSecondSeparator = $($paginationFirstSeparator[0] ? $paginationFirstSeparator[0].outerHTML : '');
        const allowPrismaResponsiveSpaceHorizontal = Odigeo._.isBoolean(options.allowPrismaResponsiveSpaceHorizontal)
            ? options.allowPrismaResponsiveSpaceHorizontal
            : _options.allowPrismaResponsiveSpaceHorizontal;
        const paginationClasses = allowPrismaResponsiveSpaceHorizontal && ( Odigeo.AB.isCssVariationMobile || Odigeo.SessionScope.isMetaFlights )
            ? 'prisma-responsive-space-horizontal pagination_wrapper'
            : 'od-pagination-wrapper pagination_wrapper';
        var $wrapper = $(paginationType !=='loadMore' ? '<ul>' : '<div>', {'class': paginationClasses}).appendTo($selector);
        var $element = $('<li>', {'class': 'od-pagination-item'});

        // Behaviour vars
        var actualPage = 0;
        var numberOfResultPages = 0;
        var _nextResults = function() {
            if (actualPage === numberOfResultPages) {
                return;
            }

            if (Odigeo._.isFunction(options.nextCallback)) {
                options.nextCallback();
                _options.loadTrackingCallback();
                $selector.trigger('paginate');
            }
        };
        var _previousResults = function() {
            if (actualPage === 1) {
                return;
            }

            if (Odigeo._.isFunction(options.previousCallback)) {
                options.previousCallback();
                _options.loadTrackingCallback();
                $selector.trigger('paginate');
            }
        };
        var _goToPage = function() {
            var $pageButton = $(this).find('.page_button');

            if ($pageButton.hasClass('selected')) {
                return false;
            }

            if (Odigeo._.isFunction(options.loadPageCallback)) {
                _options.loadPageCallback($pageButton.data('page'));
                _options.loadTrackingCallback();
                $selector.trigger('paginate');
            }
        };
        var _hideSeparators = function() {
            $paginationFirstSeparator.addClass('hidden');
            $paginationSecondSeparator.addClass('hidden');
        };

        var _repaintUIElement = function(event, thisPage, totalPages) {
            numberOfResultPages = totalPages;
            actualPage = thisPage;

            if (actualPage === totalPages) {
                $nextButton.addClass('disabled').find('button').prop('disabled', true);
            } else {
                $nextButton.removeClass('disabled').find('button').prop('disabled', false);
            }

            if (actualPage === 1) {
                $previousButton.addClass('disabled').find('button').prop('disabled', true);
            } else {
                $previousButton.removeClass('disabled').find('button').prop('disabled', false);
            }

            switch (paginationType) {
                case 'nPagesSet':
                    $previousButton.toggleClass('hidden', numberOfResultPages === 1);
                    $nextButton.toggleClass('hidden', numberOfResultPages === 1);
                    // less pages than the max page set
                    if (numberOfResultPages <= _options.maxnumberOfResultPagesShown) {
                        // hide separators
                        _hideSeparators();
                        // iterate through each button, and hide non necessary ones
                        $wrapper.find('.page_button').each(function(index, el) {
                            var buttonIndex = index + 1;
                            var $el = $(el);
                            if (buttonIndex <= numberOfResultPages) {
                                $el.data('page', buttonIndex).removeClass('hidden').
                                    toggleClass('selected', actualPage === buttonIndex);
                                $el.find('.page_number_text').html(buttonIndex);
                            } else {
                                $el.data('page', buttonIndex).addClass('hidden');
                            }
                        });
                        // more pages than max page set
                    } else {
                        // If we are at the start
                        if (actualPage < _options.maxnumberOfResultPagesShown) {
                            $paginationFirstSeparator.addClass('hidden');
                            $paginationSecondSeparator.toggleClass('hidden', (_options.maxnumberOfResultPagesShown + 1 === numberOfResultPages));

                            $wrapper.find('.page_button').each(function(index, el) {
                                var buttonIndex = index + 1;
                                var $el = $(el);
                                if (buttonIndex <= _options.maxnumberOfResultPagesShown) {
                                    $el.data('page', buttonIndex).removeClass('hidden').
                                        toggleClass('selected', actualPage === buttonIndex);
                                    $el.find('.page_number_text').html(buttonIndex);
                                } else {
                                    if (buttonIndex === (_options.maxnumberOfResultPagesShown + 1)) {
                                        $el.data('page', 0).addClass('hidden');
                                    } else {
                                        $el.data('page', numberOfResultPages).removeClass('hidden selected');
                                        $el.find('.page_number_text').html(numberOfResultPages);
                                    }
                                }
                            });
                            // else if we are at the end
                        } else if (numberOfResultPages - actualPage + 1 < _options.maxnumberOfResultPagesShown) {
                            $paginationFirstSeparator.toggleClass('hidden', (_options.maxnumberOfResultPagesShown + 1 === numberOfResultPages));
                            $paginationSecondSeparator.addClass('hidden');
                            $wrapper.find('.page_button').each(function(index, el) {
                                var buttonIndex = index + 1;
                                var buttonPageEquivalent = numberOfResultPages + (index - _options.maxnumberOfResultPagesShown);
                                var $el = $(el);

                                if (buttonIndex > 1) {
                                    if (buttonIndex === _options.maxnumberOfResultPagesShown + 2) {
                                        $el.data('page', 0).addClass('hidden');
                                    } else {
                                        $el.data('page', buttonPageEquivalent).removeClass('hidden').
                                            toggleClass('selected', actualPage === buttonPageEquivalent);
                                        $el.find('.page_number_text').html(buttonPageEquivalent);
                                    }
                                } else {
                                    $el.data('page', 1).removeClass('hidden selected');
                                    $el.find('.page_number_text').html(1);
                                }
                            });
                            // else we are at the middle
                        } else {
                            $paginationFirstSeparator.removeClass('hidden');
                            $paginationSecondSeparator.removeClass('hidden');
                            $wrapper.find('.page_button').each(function(index, el) {
                                var buttonIndex = index + 1;
                                var buttonPageEquivalent = actualPage + (buttonIndex - (Math.ceil(_options.maxnumberOfResultPagesShown / 2) + 1));
                                var $el = $(el);

                                if (buttonIndex === 1 || buttonIndex === _options.maxnumberOfResultPagesShown + 2) {
                                    $el.data('page', buttonIndex === 1 ? 1 : numberOfResultPages).removeClass('hidden selected');
                                    $el.find('.page_number_text').html(buttonIndex === 1 ? 1 : numberOfResultPages);
                                } else {
                                    $el.data('page', buttonPageEquivalent).removeClass('hidden').
                                        toggleClass('selected', actualPage === buttonPageEquivalent);
                                    $el.find('.page_number_text').html(buttonPageEquivalent);
                                }
                            });
                        }
                    }
                    break;
                case 'blockPagesSet':
                    var actualBlockStart = 0;
                    var fixedPosition = Math.floor(_options.maxnumberOfResultPagesShown / 2);

                    if (actualPage <= fixedPosition + 1 || totalPages <= _options.maxnumberOfResultPagesShown) {
                        actualBlockStart = 1;
                    } else if (actualPage >= totalPages - fixedPosition) {
                        actualBlockStart = totalPages - (_options.maxnumberOfResultPagesShown - 1);
                    } else {
                        actualBlockStart = actualPage - fixedPosition;
                    }

                    // hide separators
                    _hideSeparators();
                    // iterate through each button, and hide non necessary ones
                    $wrapper.find('.page_button').each(function(index, el) {
                        var $el = $(el);
                        if (actualBlockStart + index <= totalPages) {
                            $el.data('page', actualBlockStart + index).removeClass('hidden').
                                toggleClass('selected', actualPage === actualBlockStart + index);
                            $el.find('.page_number_text').html(actualBlockStart + index);
                        } else {
                            $el.data('page', 0).addClass('hidden');
                        }
                    });
                    break;
                default:
                    return;
            }
        };

        Odigeo._.extend(_options, options);

        // initialize and construct
        var i;
        switch (paginationType) {
            case 'loadMore':
                $nextButton.appendTo($wrapper);
                $nextButton.on(Odigeo.Events.tap, _nextResults);
                break;
            case 'nPagesSet':
                $element.clone().addClass('previous_button').append($previousButton).appendTo($wrapper).
                    on(Odigeo.Events.tap, _previousResults);
                $element.clone().append($pageTemplateButton.data('page', 1)).appendTo($wrapper).addClass('selected').
                    on(Odigeo.Events.tap, _goToPage);
                $element.clone().append($paginationFirstSeparator).appendTo($wrapper);

                for (i = 0; i < _options.maxnumberOfResultPagesShown; i++) {
                    $element.clone().append($pageTemplateButton.clone().data('page', i + 2)).appendTo($wrapper).
                        on(Odigeo.Events.tap, _goToPage);
                }
                $element.clone().append($paginationSecondSeparator).appendTo($wrapper);
                $element.clone().append($pageTemplateButton.clone().data('page', _options.maxnumberOfResultPagesShown + 1)).appendTo($wrapper).
                    on(Odigeo.Events.tap, _goToPage);
                $element.clone().addClass('next_button').append($nextButton).appendTo($wrapper).
                    on(Odigeo.Events.tap, _nextResults);
                break;
            case 'blockPagesSet':
                $element.clone().addClass('previous_button').append($previousButton).appendTo($wrapper).
                    on(Odigeo.Events.tap, _previousResults);
                $element.clone().append($pageTemplateButton.data('page', 1)).appendTo($wrapper).
                    on(Odigeo.Events.tap, _goToPage);
                for (i = 1; i < _options.maxnumberOfResultPagesShown; i++) {
                    $element.clone().append($pageTemplateButton.clone().data('page', i)).appendTo($wrapper).
                        on(Odigeo.Events.tap, _goToPage);
                }

                $element.clone().addClass('next_button').append($nextButton).appendTo($wrapper).
                    on(Odigeo.Events.tap, _nextResults);
                break;
            default:
                // do nothing;
                return;
        }
        $selector.bind('repaintPagination', Odigeo._.bind(_repaintUIElement, this));
    };
}());
